<section
  *ngIf="showPopup"
  role="alert"
  class="mt-2 rounded-xl border p-4"
  [ngClass]="{
    'bg-lime-50 border-green-200': success,
    'bg-red-50 border-red-200': !success
  }"
>
  <section class="flex items-start gap-4">
    <!-- Icon -->
    <span [ngClass]="success ? 'text-green-600' : 'text-red-600'">
      <svg
        *ngIf="success"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>

      <svg
        *ngIf="!success"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v2.25m0 4.5h.008v.008H12v-.008zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </span>

    <!-- Text -->
    <section class="flex-1">
      <strong
        class="block font-medium"
        [ngClass]="success ? 'text-green-900' : 'text-red-900'"
      >
        {{ majorMessage }}
      </strong>
      <p
        class="mt-1 text-sm"
        [ngClass]="success ? 'text-gray-700' : 'text-red-700'"
      >
        {{ minorMessage }}
      </p>
    </section>

    <!-- Dismiss button -->
    <button
      (click)="showPopup = false"
      class="text-gray-500 transition hover:text-gray-600"
    >
      <span class="sr-only">Dismiss popup</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </section>
</section>
